import { render, staticRenderFns } from "./CardsListWidget.vue?vue&type=template&id=037dfd3e&"
import script from "./CardsListWidget.vue?vue&type=script&lang=js&"
export * from "./CardsListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports